import { supabase, SUPABASE_URL, SUPABASE_ANON_KEY } from './supabase';

const EDGE_FUNCTIONS_URL = `${SUPABASE_URL}/functions/v1`;
const GUEST_ID_KEY = 'hangrily_guest_id';

function getGuestId() {
  try {
    let id = localStorage.getItem(GUEST_ID_KEY);
    if (!id) {
      id = (crypto.randomUUID ? crypto.randomUUID() :
        'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          const r = Math.random() * 16 | 0;
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        }));
      localStorage.setItem(GUEST_ID_KEY, id);
    }
    return id;
  } catch {
    return null;
  }
}

async function callEdgeFunction(functionName, path, options = {}) {
  const { method = 'POST', body } = options;

  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;

  const headers = {
    'Content-Type': 'application/json',
    'apikey': SUPABASE_ANON_KEY,
  };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    const guestId = getGuestId();
    if (guestId) headers['x-guest-id'] = guestId;
  }

  const url = `${EDGE_FUNCTIONS_URL}/${functionName}${path}`;
  const res = await fetch(url, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json();

  if (!res.ok) {
    const error = new Error(data.error || `Request failed with status ${res.status}`);
    error.response = { status: res.status, data };
    throw error;
  }

  return { data };
}

function parsePath(path) {
  let clean = path.startsWith('/api/') ? path.slice(4) : path;
  if (clean.startsWith('/')) clean = clean.slice(1);

  const firstSlash = clean.indexOf('/');
  if (firstSlash === -1) {
    return { fn: clean, subpath: '' };
  }

  const fn = clean.slice(0, firstSlash);
  const subpath = clean.slice(firstSlash);
  return { fn, subpath };
}

const api = {
  post: (path, body) => {
    const { fn, subpath } = parsePath(path);
    return callEdgeFunction(fn, subpath, { method: 'POST', body });
  },
  get: (path) => {
    const { fn, subpath } = parsePath(path);
    return callEdgeFunction(fn, subpath, { method: 'GET' });
  },
  put: (path, body) => {
    const { fn, subpath } = parsePath(path);
    return callEdgeFunction(fn, subpath, { method: 'PUT', body });
  },
  delete: (path, body) => {
    const { fn, subpath } = parsePath(path);
    return callEdgeFunction(fn, subpath, { method: 'DELETE', body });
  },
  patch: (path, body) => {
    const { fn, subpath } = parsePath(path);
    return callEdgeFunction(fn, subpath, { method: 'PUT', body });
  },
};

export default api;
export { EDGE_FUNCTIONS_URL, callEdgeFunction };
